import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoTimerStopwatch = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>TimerStopwatch</title>
    <path
      d="M16.313 12.066v6.897l2.758 2.758"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m15.854 6.578-.788.093m0 0c-.185.026-.37.057-.555.092m.555-.092-.555.092m0 0a11.2 11.2 0 0 0-1.033.248c-5.745 1.673-9.126 7.642-7.57 13.45 1.578 5.888 7.63 9.382 13.516 7.804 5.887-1.577 9.381-7.628 7.804-13.516a10.986 10.986 0 0 0-2.638-4.725M15.883 4.48v2.068M13.124 3.79h5.517"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.866 12.682V8.45h4.232"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoTimerStopwatch;
